module.exports = __webpack_public_path__ + "img/madera2.214ab369.jpg";